export default __webpack_public_path__ + "static/media/Product-List.ba78e08b.jpg";